export default function () {
  return {
    headData: [
      {
        name: 'item',
        columnProps: {
          prop: 'item',
          label: '类型',
        },
      },
      {
        name: 'lossAmount',
        columnProps: {
          prop: 'lossAmount',
          label: '定损金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.lossAmount),
      },
      {
        name: 'receivableTypeName',
        columnProps: {
          prop: 'receivableTypeName',
          label: '应收收取方式',
        },
      },
      {
        name: 'receivableProportionName',
        columnProps: {
          prop: 'receivableProportionName',
          label: '应收占比',
        },
      },
      {
        name: 'receivableAmount',
        columnProps: {
          prop: 'receivableAmount',
          label: '应收金额',
        },
        getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          prop: 'remarks',
          label: '备注',
        },
      },
    ],
  }
}
